// @flow
import * as React from 'react';

type Data = ?{
    data: Array<Object>,
    limit: number,
    offset: number,
    next: ?string,
}

const usePaginateData = (data: Data, callback: Function, args: Array<any>, afterCallback: Function = () => {}) => {
    const [allData, setAllData] = React.useState([]);
    const [moreData, setMoreData] = React.useState(true);

    React.useEffect(() => {
        if (!data) return;

        if (data.data) {
            setAllData([...allData, ...data.data]);
        }

        if (data.next) {
            callback(...args, data.limit, data.offset + data.limit);
        } else {
            setMoreData(false);
            afterCallback();
        }
    }, [data]);

    const handleReset = () => {
        setAllData([]);
        setMoreData(true);
    };

    return [allData, moreData, handleReset];
};

export default usePaginateData;
